import { API_ROUTE_ADMIN_DEPARTMENT } from '@/resources/api-routes'
import { update } from '@/util/auth'

import type { DepartmentOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const updateDepartment = async ({
  id,
  payload,
}: {
  id: number
  payload: Pick<
    DepartmentOriginal,
    | 'name'
    | 'code'
    | 'customerId'
    | 'userId'
    | 'deputyUserId'
    | 'project'
    | 'deputyMail'
    | 'inactive'
  >
}) =>
  (
    await update<{ department: DepartmentOriginal }>(
      API_ROUTE_ADMIN_DEPARTMENT.replace(':departmentId', String(id)),
      payload,
      IS_NEW_BACKEND_API
    )
  ).department
